import { GoogleCustomEvent, GoogleStandardEvents } from '@xyo-network/sdk-xyo-react-js';
class GoogleEvents extends GoogleStandardEvents {
    contactInfoComplete() {
        return new GoogleCustomEvent('ContactInfoComplete', 'wStWCNWE1-8BEOjZhtgD');
    }
    addressInfoComplete() {
        return new GoogleCustomEvent('AddressInfoComplete', 'b119CLj8lPABEOjZhtgD');
    }
    paymentInfoComplete() {
        return new GoogleCustomEvent('PaymentInfoComplete', 'EvwsCLGh9e8BEOjZhtgD');
    }
    transactionAttempted() {
        return new GoogleCustomEvent('TransactionAttempted');
    }
    transactionFailed() {
        return new GoogleCustomEvent('TransactionFailed');
    }
    transactionCompleted() {
        return new GoogleCustomEvent('TransactionCompleted', 'Sw3uCICj9e8BEOjZhtgD');
    }
    upsellViewed() {
        return new GoogleCustomEvent('UpsellViewed');
    }
    upsellUnavailable() {
        return new GoogleCustomEvent('UpsellUnavailable');
    }
    upsellAccepted() {
        return new GoogleCustomEvent('UpsellAccepted');
    }
    upsellSucceeded() {
        return new GoogleCustomEvent('UpsellSucceeded', '8ubgCM6DlfABEOjZhtgD');
    }
    upsellFailed() {
        return new GoogleCustomEvent('UpsellFailed');
    }
    trialStarted() {
        return new GoogleCustomEvent('TrialStarted');
    }
    testStarted() {
        return new GoogleCustomEvent('TestStarted');
    }
    funnelStarted() {
        return new GoogleCustomEvent('FunnelStarted');
    }
    viewContent() {
        return new GoogleCustomEvent('ViewContent');
    }
    userClick() {
        return new GoogleCustomEvent('UserClick');
    }
}
export default GoogleEvents;
